// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Hxop","header":"MessagesList_header__2Fwhb","chat":"MessagesList_chat__26etL"};